/**
 * This reducer is used for validating products while adding to cart
 */
import {
    VALIDATE_PRODUCTS,
    VALIDATE_PRODUCTS_SUCCESS,
    VALIDATE_PRODUCTS_FAILURE,
    CLEAR_VALIDATED_PRODUCTS,
    VALIDATE_REPLEN,
    VALIDATE_REPLEN_SUCCESS,
    VALIDATE_REPLEN_FAILURE,
    CLEAR_ERROR,
    CLEAR_VALIDATE_REPLEN,
} from '../actions';

const initialState = {
    validatedProducts: [],
    loading: false,
    statusCode: 0,
    statusMessage: '',
    showShipToAddressPopup:false,
    productsWithError:'',
    callApplyShipToFunc: false,
};

const validateProductsReducer = (state = initialState, action) => {
    switch (action.type) {
        case VALIDATE_PRODUCTS:
            return {
                ...state,
                validatedProducts: [],
                loading: true,
                statusCode: 0,
            };
        case VALIDATE_PRODUCTS_SUCCESS:
            return {
                ...state,
                validatedProducts: [...action.validatedProducts],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case VALIDATE_PRODUCTS_FAILURE:
            return {
                ...state,
                validatedProducts: [],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case VALIDATE_REPLEN:
            return {
                ...state,
                isProductsValidationInProgress: true,
            };
        case VALIDATE_REPLEN_SUCCESS:
        case VALIDATE_REPLEN_FAILURE:
            return {
                ...state,
                isProductsValidationInProgress: false,
                accountError: action?.accountError,
                surgeonError: action?.surgeonError,
                showShipToAddressPopup: action?.showShipToAddressPopup,
                productsWithError: action?.productsWithError,
                callApplyShipToFunc : !state.callApplyShipToFunc
            };
        case CLEAR_ERROR:
            return {
                ...state,
                accountError: initialState.accountError,
                surgeonError: initialState.surgeonError,
            };
        case CLEAR_VALIDATE_REPLEN:
            return {
                ...state,
                accountError: initialState.accountError,
                surgeonError: initialState.surgeonError,
                showShipToAddressPopup: initialState.showShipToAddressPopup,
            };
        case CLEAR_VALIDATED_PRODUCTS:
            return {
                ...state,
                validatedProducts: [],
                accountError: initialState.accountError,
                surgeonError: initialState.surgeonError,
            };

        default: {
            return { ...state };
        }
    }
};

export default validateProductsReducer;
